import styled from "styled-components";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Heading } from "components/ui/Text";
import IconList from "components/ui/IconList";
import { getUserProfile } from "store/api/apiSlice";
import { getItems } from "./constants";
import Modal, { ModalApi } from "../Modal";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  text-align: left;
`;

const DslZeroModal = (
  { onClose }: { onClose?: () => void },
  forwardedRef: React.ForwardedRef<unknown>
) => {
  const ref = useRef<ModalApi>(null);
  useImperativeHandle(forwardedRef, () => ref.current);
  const { data: userProfile } = getUserProfile();

  if (!userProfile) return null;

  const items = getItems(userProfile);

  return (
    <Modal ref={ref} onClose={onClose}>
      <Wrapper>
        <Heading.H3 tag="h2">Why is my spending limit&nbsp;$0?</Heading.H3>

        <IconList items={items} />
      </Wrapper>
    </Modal>
  );
};

export default forwardRef(DslZeroModal);
